import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnfrageDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { StateService } from '@/core/services/state.service';
import { FormularService } from '@/core/services/formular.service';
import { AbschnittDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model';
import { NavigationItem } from '@/core/models/navigation-item.model';
import { ValidationFailure } from '@/api/models/FluentValidation/Results/validation-failure';
import { PortalContextService } from '@/core/services/portal-context.service';
import { AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode, GlobalEnumsAceTypprojektbericht, LocalizedTextDisplayModel, ProjektberichtDisplayModel } from '@/api/model-index';
import { I18nService } from '@/core/services/i18nService';
import { formatDate } from '@angular/common';
import { AnfrageService } from '@/api/service-index';

@Component({
  selector: 'app-anfrage-report-detail',
  templateUrl: './anfrage-report-detail.component.html',
  styleUrls: ['./anfrage-report-detail.component.scss']
})
export class AnfrageReportDetailComponent implements OnInit, OnDestroy {
  protected _navItemList: NavigationItem[] | null;

  public anfrage: AnfrageDisplayModel;
  public area: { [key: string]: ValidationFailure[] };

  public get showProzessNavigation() {
    return this.stateService.showProzessNavigation;
  }

  public get showAnfrageInfo() {
    return this.stateService.showAnfrageInfo;
  }

  public get showAbsenden(): boolean {
    return !this.portalContextService.isAnfrageDisabled();
  }

  public get GetAbsendenText(): LocalizedTextDisplayModel[] {
    var list = this.languageservice.supportedLanguages.map(lang => {
      let text = new LocalizedTextDisplayModel();
      text.text = this.languageservice.instantForSpecificLanguage('submitdialogue.submit_send', lang)
      lang = lang.split('-')[0];
      text.localeCode = lang;
      return text;
    })
    return list;
  }

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected formularService: FormularService,
    protected stateService: StateService,
    protected portalContextService: PortalContextService,
    protected languageservice: I18nService,
    protected anfrageService: AnfrageService) {

    this.anfrage = this.portalContextService.CurrentAnfrage;
    this.area = this.route.snapshot.data.area;

    this.stateService.ValidationErrors = this.area;

    this.languageservice.languageChanged$.subscribe(() => {
      this.ngOnInit();
    });


    this.portalContextService.BerichtChanged.subscribe((bericht) => {
      this.fetchValidationErrors(bericht);
    });
    this.fetchValidationErrors(this.portalContextService.CurrentBericht);
  }
  
  protected fetchValidationErrors(bericht: ProjektberichtDisplayModel | null) {
    this.stateService.ValidationErrors = null;
    if (bericht) {
      this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.portalContextService.CurrentAnfrage.id, reportId: bericht.projektberichtId }).subscribe(data => {
        this.area = data;
        this.stateService.ValidationErrors = this.area;
      });
    }
  }

  public get navItemList() {
    return this._navItemList;
  }

  ngOnInit(): void {

    //Erstellt für die Parent Abschnitte/Report den Namen
    this.anfrage.phase?.abschnitte?.forEach((abschnitt: AbschnittDisplayModel) => {
      let localizedAbschnittName = new LocalizedTextDisplayModel();
      localizedAbschnittName.localeCode = this.languageservice.language;

      let foundBericht = this.portalContextService.Berichte?.find(bericht => bericht.projektberichtId == abschnitt.id);
      let dateVon = foundBericht?.datumVon ? formatDate(new Date(Date.parse(foundBericht.datumVon)), this.languageservice.GetCurrentShortDateFormat(), this.languageservice.language) : "";
      let dateBis = foundBericht?.datumBis ? formatDate(new Date(Date.parse(foundBericht.datumBis)), this.languageservice.GetCurrentShortDateFormat(), this.languageservice.language) : "";

      let combinedDate = dateVon;
      if (dateVon && dateBis)
        combinedDate += " - " + dateBis;

      let projektberichtTypen = GlobalEnumsAceTypprojektbericht.getAsDataset();
      projektberichtTypen.forEach(x => x.Description = this.languageservice.instant("Enum.projektbericht." + x.Name));
      localizedAbschnittName.text = projektberichtTypen.find(typ => typ.Value == foundBericht?.typ)?.Description + " " + combinedDate;

      abschnitt.kurzTitel = [localizedAbschnittName];
    })

    this._navItemList = this.getNavItems(this.anfrage.phase?.abschnitte);
    this._navItemList?.forEach(navItem => {
      navItem.children = this.getNavItems(navItem.childAbschnitte);
    });
  }

  public showValidationStatus(abschnittId: string | undefined): boolean {
    let foundBericht = this.portalContextService.Berichte?.find(bericht => bericht.projektberichtId == abschnittId);
    return foundBericht != null && this.portalContextService.isBerichtOpen(foundBericht);
  }

  public iconReportStatus(abschnittId: string | undefined): string {
    let foundBericht = this.portalContextService.Berichte?.find(bericht => bericht.projektberichtId == abschnittId);

    switch (foundBericht?.status) {
      case AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.inBearbeitung:
        return "edit";
      case AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.Eingereicht:
        return "preview";
      case AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.Gepruft:
        return "check";
    }
    return "";
  }

  public iconReportStatusTitle(abschnittId: string | undefined): string {
    let foundBericht = this.portalContextService.Berichte?.find(bericht => bericht.projektberichtId == abschnittId);

    switch (foundBericht?.status) {
      case AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.inBearbeitung:
        return "icon_report_status_title.edit";
      case AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.Eingereicht:
        return "icon_report_status_title.preview";
      case AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode.Gepruft:
        return "icon_report_status_title.check";
    }
    return "";
  }

  public isCurrentRoute(parentAbschnitt: AbschnittDisplayModel, childAbschnitt?: AbschnittDisplayModel): boolean {
    let abschnittId: string | null = <string>this.route.firstChild?.snapshot.params['abschnittid'];
    let reportId: string | null = <string>this.route.firstChild?.snapshot.params['reportid'];

    if (!abschnittId) return false;
    if (!reportId) return false;

    return childAbschnitt != null && childAbschnitt.id == abschnittId && childAbschnitt.parentId == reportId;
  }

  public isDataprotectionRoute() {
    let urlSegments = this.router.url.split("/");

    if (urlSegments.includes("dataprotection"))
      return true;

    return false;
  }

  public isParentOpen(parentAbschnitt: AbschnittDisplayModel) {
    let abschnittId: string | null = <string>this.route.firstChild?.snapshot.params['abschnittid'];
    let reportId: string | null = <string>this.route.firstChild?.snapshot.params['reportid'];
    let isOpen = false;

    if (this.isDataprotectionRoute() && parentAbschnitt.id == reportId)
      isOpen = true;

    // If parent is active and has children
    if (parentAbschnitt.abschnitte && this.isCurrentRoute(parentAbschnitt)) {
      isOpen = true;
    }

    // If a child was found in parent, then show group
    let childAbschnitt = parentAbschnitt.abschnitte?.find(a => a.id == abschnittId && a.parentId == reportId);
    if (childAbschnitt) {
      isOpen = true;
    }

    return isOpen;
  }

  public getStatusFor(abschnittId: string | undefined): number {
    if (!abschnittId)
      return 0;

    //Wenn es keine Validierungsfehler gibt, dann ist der Abschnitt valide
    if (abschnittId == 'dataprotection'
      || !this.stateService.ValidationErrors
      || !this.stateService.ValidationErrors[abschnittId]
      || this.stateService.ValidationErrors[abschnittId].length == 0)
      return 1;

    return 0;
  }

  public getNavItems(abschnitte: AbschnittDisplayModel[] | null | undefined): NavigationItem[] | null {
    let navItems: NavigationItem[] = [];

    if (abschnitte) {
      abschnitte.forEach(abschnitt => {
        let item = this.getNavItem(abschnitt);
        if (item)
          navItems.push(item);
      });
    }
    return navItems;
  }

  protected getNavItem(abschnitt: AbschnittDisplayModel): NavigationItem | null {
    if (abschnitt.formularTyp == undefined)
      return null;

    let navItem: NavigationItem = this.formularService.getRouteObjectThrough(abschnitt);
    navItem.abschnitt = abschnitt;
    navItem.childAbschnitte = abschnitt.abschnitte ?? [];
    let defaulttext = new LocalizedTextDisplayModel();
    defaulttext.localeCode = this.languageservice.language;
    defaulttext.text = abschnitt.name ?? ""
    navItem.name = abschnitt.kurzTitel ?? [defaulttext];
    navItem.formularTyp = abschnitt.formularTyp;

    navItem.link = "../" + (abschnitt.parentId ?? abschnitt.id) + '/' + navItem.link;

    return navItem;
  }

  public getLink(navItem: NavigationItem): string {
    if (navItem.children)
      return navItem.children[0].link;

    throw "Dieser Report hat keine Abschnitte"
  }

  protected nullReference: AnfrageDisplayModel;
  public ngOnDestroy(): void {
    this.portalContextService.CurrentAnfrage = this.nullReference;
    this.portalContextService.Berichte = [];
    this.portalContextService.CurrentBericht = null;
    this.stateService.ValidationErrors = null;
  }
}
